module.exports = __webpack_public_path__ + "img/lens-167-minus-04.e71c8975.png";